"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserIcon = exports.LockIcon = exports.Success = void 0;

var react_1 = __importDefault(require("react"));

var Success = function Success(props) {
  return react_1.default.createElement("svg", Object.assign({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 3 16 16"
  }), react_1.default.createElement("defs", null, react_1.default.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: "-2.623",
    x2: "0",
    y1: "986.67",
    id: "0"
  }, react_1.default.createElement("stop", {
    stopColor: "#ffce3b"
  }), react_1.default.createElement("stop", {
    offset: "1",
    stopColor: "#ffd762"
  })), react_1.default.createElement("linearGradient", {
    y2: "-2.623",
    x2: "0",
    y1: "986.67",
    gradientUnits: "userSpaceOnUse"
  }, react_1.default.createElement("stop", {
    stopColor: "#ffce3b"
  }), react_1.default.createElement("stop", {
    offset: "1",
    stopColor: "#fef4ab"
  }))), react_1.default.createElement("g", {
    transform: "matrix(1.99997 0 0 1.99997-10.994-2071.68)",
    fill: "#da4453"
  }, react_1.default.createElement("rect", {
    y: "1037.36",
    x: "7",
    height: "8",
    width: "8",
    fill: "#32c671",
    rx: "4"
  }), react_1.default.createElement("path", {
    d: "m123.86 12.966l-11.08-11.08c-1.52-1.521-3.368-2.281-5.54-2.281-2.173 0-4.02.76-5.541 2.281l-53.45 53.53-23.953-24.04c-1.521-1.521-3.368-2.281-5.54-2.281-2.173 0-4.02.76-5.541 2.281l-11.08 11.08c-1.521 1.521-2.281 3.368-2.281 5.541 0 2.172.76 4.02 2.281 5.54l29.493 29.493 11.08 11.08c1.52 1.521 3.367 2.281 5.54 2.281 2.172 0 4.02-.761 5.54-2.281l11.08-11.08 58.986-58.986c1.52-1.521 2.281-3.368 2.281-5.541.0001-2.172-.761-4.02-2.281-5.54",
    fill: "#fff",
    transform: "matrix(.0436 0 0 .0436 8.177 1039.72)",
    stroke: "none",
    strokeWidth: "9.512"
  })));
};

exports.Success = Success;

var LockIcon = function LockIcon(props) {
  return react_1.default.createElement("svg", Object.assign({}, props, {
    width: "19",
    height: "23",
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), react_1.default.createElement("g", {
    opacity: "0.5"
  }, react_1.default.createElement("path", {
    d: "M18.1562 20.2717V12.0984C18.1562 10.6229 16.9525 9.4192 15.4771 9.4192H14.8026V5.64871C14.8026 2.53396 12.2687 0 9.15391 0C6.03915 0 3.50988 2.53864 3.50988 5.64871V6.29977C3.50988 6.74473 3.87054 7.1007 4.31082 7.1007C4.7511 7.1007 5.11644 6.74005 5.11644 6.29977V5.64871C5.11644 3.4192 6.92908 1.60656 9.15859 1.60656C11.3881 1.60656 13.2007 3.4192 13.2007 5.64871V9.4192H2.83541C1.36 9.4192 0.15625 10.6183 0.15625 12.0984V20.2717C0.15625 21.7471 1.36 22.9508 2.83541 22.9508H15.4818C16.9572 22.9461 18.1562 21.7471 18.1562 20.2717ZM1.76749 20.2717V12.0984C1.76749 11.5082 2.24993 11.0258 2.84009 11.0258H15.4818C16.0719 11.0258 16.5544 11.5082 16.5544 12.0984V20.2717C16.5544 20.8618 16.0719 21.3443 15.4818 21.3443H2.83541C2.24524 21.3396 1.76749 20.8618 1.76749 20.2717Z",
    fill: "black"
  }), react_1.default.createElement("path", {
    d: "M9.15535 14.3887C8.71039 14.3887 8.34973 14.7493 8.34973 15.1896V17.2645C8.34973 17.7095 8.71039 18.0655 9.15535 18.0655C9.60032 18.0655 9.95629 17.7048 9.95629 17.2645V15.1896C9.95629 14.7493 9.60032 14.3887 9.15535 14.3887Z",
    fill: "black"
  })));
};

exports.LockIcon = LockIcon;

var UserIcon = function UserIcon(props) {
  return react_1.default.createElement("svg", Object.assign({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "23",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000"
  }), react_1.default.createElement("g", {
    opacity: "0.5"
  }, react_1.default.createElement("path", {
    d: "M594.7,990H405.3c-179.8,0-321.7,0-321.7-96.1v-19.2c0-180.1,144.4-326.6,321.7-326.6h189.5c177.4,0,321.7,146.5,321.7,326.6v19.2C916.4,990,767.3,990,594.7,990L594.7,990z M405.2,605.7c-146.6,0-265.8,120.6-265.8,269v19.2c0,38.4,153.6,38.4,265.8,38.4h189.5c92.9,0,265.8,0,265.8-38.4v-19.2c0-148.3-119.2-269-265.8-269H405.2L405.2,605.7z M490.5,528.8c-140.9,0-255.4-116.4-255.4-259.4c0-143,114.6-259.4,255.4-259.4c140.8,0,255.4,116.3,255.4,259.4C745.9,412.4,631.3,528.8,490.5,528.8L490.5,528.8z M291,269.4c0,111.2,89.5,201.8,199.5,201.8c110,0,199.4-90.5,199.4-201.8c0-111.2-89.5-201.7-199.4-201.7C380.5,67.7,291,158.1,291,269.4L291,269.4z"
  })));
};

exports.UserIcon = UserIcon;